module.exports = __webpack_public_path__ + "img/1440.5003ca59.jpg";